import classNames from 'classnames';
import React from 'react';
import styles from './Caption.module.scss';
function Caption({ as: Tag = 'p', size = 'm', color = 'strong', children }) {
    const classes = classNames(styles.wrap, styles[size], styles[color]);
    return React.createElement(Tag, { className: classes }, children);
}
export default Caption;
